import { supabase } from '../../utils/supabase';
import { Vendor } from '../../types/vendors';
import { VendorCreate, VendorUpdate } from './types';

export const vendorApi = {
  async fetchAll(userId: string) {
    const { data, error } = await supabase
      .from('vendors')
      .select('*')
      .eq('user_id', userId);

    if (error) throw error;
    return data as Vendor[];
  },

  async create(vendor: VendorCreate, userId: string) {
    const { data, error } = await supabase
      .from('vendors')
      .insert([{ ...vendor, user_id: userId }])
      .select()
      .single();

    if (error) throw error;
    return data as Vendor;
  },

  async update({ id, ...updates }: VendorUpdate) {
    const { data, error } = await supabase
      .from('vendors')
      .update(updates)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data as Vendor;
  },

  async delete(id: string) {
    const { error } = await supabase
      .from('vendors')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return id;
  }
};